import React, { useEffect, useState } from "react";
import Footer from "../../components/footer/Footer";
import Navigation from "../../components/navigation/Navigation";
import "./service.css";
import queryString from "query-string";
import ServiceProviderCard from "../../components/serviceProviderCard/ServiceProviderCard";
import serviceProviders from "../../assets/data/providers.json";
import { Col, Row, Spinner } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const renderLoading = () => (
  <div style={{ display: "flex", justifyContent: "center", padding: "10rem" }}>
    <Spinner animation="border" variant="dark" />
  </div>
);

function Service() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [serviceData, setServiceData] = useState();

  useEffect(() => {
    setLoading(true);

    window.scrollTo(0, 0);

    const { service } = queryString.parse(window.location.search);

    axios
      .get(
        `https://the-outlet-vendor-api.herokuapp.com/vendor-services?serviceId=${service}`
      )
      .then((res) => {
        console.log(res.data);
        setServiceData(res && res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        navigate("/error");
      });
  }, [window.location.search]);


  return (
    <div className="service">
      <Navigation
        background="theme-color"
        logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
      />

      <div className="section-1">
        <h2>{serviceData && serviceData.name}</h2>

        <div className="serviceProviders">
          {loading ? (
            renderLoading()
          ) : (
            <Row className="serviceProviders">
              {serviceData &&
                serviceData.map((provider) => (
                  <Col
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    key={provider && provider.id}
                  >
                    <ServiceProviderCard serviceProvider={provider} />
                  </Col>
                ))}
            </Row>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Service;
